import React from "react";
import "./MahabaleshwarPackage.css";

const prices = [
  { vehicle: "Sedan Cab", price: "₹12,500", seats: "Comfortable & Economical" },
  { vehicle: "Ertiga Cab", price: "₹15,500", seats: "Perfect for Families" },
  { vehicle: "Kia Carens", price: "₹18,500", seats: "Premium Family Travel" },
  { vehicle: "Innova Crysta", price: "₹20,500", seats: "Premium Comfort", recommended: true },
];

const sightseeing = [
  "Panchgani",
  "Table Land",
  "Sydney Point",
  "Parsi Point",
  "Mapro Garden",
  "Mahabaleshwar",
  "Venna Lake",
  "Arthur Seat",
  "Elephant's Head Point",
  "Kate's Point",
  "Wilson Point",
  "Old Mahabaleshwar",
];

export default function MahabaleshwarPackage() {
  return (
    <section className="mh-package">
      <div className="mh-wrapper">

        {/* Hero */}
        <div className="mh-hero">
          <div className="mh-hero-content">
            <span className="mh-eyebrow">GARUD CABS • PUNE</span>

            <h1>
              Pune to Panchgani
              <span>& Mahabaleshwar</span>
            </h1>

            <p className="mh-subtitle">
              3 Days Hill Station Tour Package
            </p>

            <div className="mh-tags">
              <span>🚕 Commercial Cab</span>
              <span>📅 3 Days</span>
              <span>⛰ Sightseeing</span>
              <span>🚘 Pune Return</span>
            </div>
          </div>

          <div className="mh-logo-box">
            <img
              src="/images/logo.jpg"
              alt="Garud Cabs"
            />
            <span>Your Journey, Our Responsibility</span>
          </div>
        </div>

        {/* Route Strip */}
        <div className="mh-route">
          <div>
            <small>START</small>
            <strong>Pune</strong>
          </div>

          <span className="mh-route-line">
            <i></i>
            <b>→</b>
          </span>

          <div>
            <small>EXPLORE</small>
            <strong>Panchgani</strong>
          </div>

          <span className="mh-route-line">
            <i></i>
            <b>→</b>
          </span>

          <div>
            <small>EXPLORE</small>
            <strong>Mahabaleshwar</strong>
          </div>

          <span className="mh-route-line">
            <i></i>
            <b>→</b>
          </span>

          <div>
            <small>RETURN</small>
            <strong>Pune</strong>
          </div>
        </div>

        {/* Content */}
        <div className="mh-content-grid">

          {/* Sightseeing */}
          <div className="mh-card mh-sightseeing">
            <div className="mh-card-title">
              <span className="mh-number">01</span>
              <div>
                <small>DISCOVER & EXPLORE</small>
                <h2>Tour Highlights</h2>
              </div>
            </div>

            <p className="mh-description">
              Enjoy a refreshing getaway from Pune covering the popular
              viewpoints, attractions and scenic destinations of Panchgani
              and Mahabaleshwar.
            </p>

            <div className="mh-spots">
              {sightseeing.map((spot, index) => (
                <div className="mh-spot" key={spot}>
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  {spot}
                </div>
              ))}
            </div>
          </div>

          {/* Package Details */}
          <div className="mh-right">

            <div className="mh-card">
              <div className="mh-card-title compact">
                <span className="mh-number">02</span>
                <div>
                  <small>TRIP DETAILS</small>
                  <h2>Package Includes</h2>
                </div>
              </div>

              <div className="mh-includes">
                <div>
                  <span>✓</span>
                  <p>
                    <strong>Commercial Cab</strong>
                    Dedicated cab for your complete trip
                  </p>
                </div>

                <div>
                  <span>✓</span>
                  <p>
                    <strong>Fuel Charges</strong>
                    Included in package
                  </p>
                </div>

                <div>
                  <span>✓</span>
                  <p>
                    <strong>Driver Allowance</strong>
                    Complete tour allowance
                  </p>
                </div>

                <div>
                  <span>✓</span>
                  <p>
                    <strong>Toll & Parking</strong>
                    Included for the journey
                  </p>
                </div>
              </div>
            </div>

            <div className="mh-note">
              <div className="mh-note-icon">i</div>
              <div>
                <strong>Package Note</strong>
                <p>
                  Guest hotel stay, meals and personal expenses are not
                  included unless specifically mentioned during booking.
                </p>
              </div>
            </div>

          </div>
        </div>

        {/* Pricing */}
        <div className="mh-pricing">
          <div className="mh-pricing-head">
            <div>
              <span>03 • CAB OPTIONS</span>
              <h2>Choose Your Ride</h2>
            </div>

            <p>
              Pune → Panchgani → Mahabaleshwar → Pune
              <strong>3 Days Package</strong>
            </p>
          </div>

          <div className="mh-price-grid">
            {prices.map((item) => (
              <div
                key={item.vehicle}
                className={`mh-price-card ${
                  item.recommended ? "recommended" : ""
                }`}
              >
                {item.recommended && (
                  <span className="mh-popular">
                    RECOMMENDED
                  </span>
                )}

                <div className="mh-car-icon">🚘</div>

                <h3>{item.vehicle}</h3>
                <p>{item.seats}</p>

                <div className="mh-divider"></div>

                <small>PACKAGE PRICE</small>
                <div className="mh-price">{item.price}</div>

                <span className="mh-duration">
                  Complete 3 Days Tour
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mh-cta">
          <div className="mh-cta-left">
            <span>PLAN YOUR HILL STATION GETAWAY</span>
            <h2>Panchgani & Mahabaleshwar Awaits!</h2>
            <p>
              Travel comfortably from Pune with Garud Cabs.
            </p>
          </div>

          <div className="mh-cta-actions">
            <a href="tel:+919970007784" className="mh-call">
              Call Now
            </a>

            <a href="#booking" className="mh-book">
              Book Package →
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}